import React, { useState } from 'react';
import axios from 'axios';
import { ENTITIES } from '../constants/entities';

function JobForm({ filiale }) {
  const countries = [
    'Afghanistan', 'Afrique du Sud', 'Albanie', 'Algérie', 'Allemagne', 'Andorre', 'Angola',
    'Arabie Saoudite', 'Argentine', 'Arménie', 'Australie', 'Autriche', 'Azerbaïdjan',
    'Bahamas', 'Bahreïn', 'Bangladesh', 'Barbade', 'Belgique', 'Belize', 'Bénin',
    'Bhoutan', 'Biélorussie', 'Bolivie', 'Bosnie-Herzégovine', 'Botswana', 'Brésil',
    'Brunei', 'Bulgarie', 'Burkina Faso', 'Burundi', 'Cambodge', 'Cameroun', 'Canada',
    'Cap-Vert', 'Chili', 'Chine', 'Chypre', 'Colombie', 'Comores', 'Congo', 'Corée du Nord',
    'Corée du Sud', 'Costa Rica', 'Côte d\'Ivoire', 'Croatie', 'Cuba', 'Danemark',
    'Djibouti', 'Dominique', 'Égypte', 'Émirats arabes unis', 'Équateur', 'Érythrée',
    'Espagne', 'Estonie', 'Eswatini', 'États-Unis', 'Éthiopie', 'Fidji', 'Finlande',
    'France', 'Gabon', 'Gambie', 'Géorgie', 'Ghana', 'Grèce', 'Grenade', 'Guatemala',
    'Guinée', 'Guinée-Bissau', 'Guinée équatoriale', 'Guyana', 'Haïti', 'Honduras',
    'Hongrie', 'Inde', 'Indonésie', 'Irak', 'Iran', 'Irlande', 'Islande', 'Israël',
    'Italie', 'Jamaïque', 'Japon', 'Jordanie', 'Kazakhstan', 'Kenya', 'Kirghizistan',
    'Kiribati', 'Kosovo', 'Koweït', 'Laos', 'Lesotho', 'Lettonie', 'Liban', 'Libéria',
    'Libye', 'Liechtenstein', 'Lituanie', 'Luxembourg', 'Macédoine du Nord', 'Madagascar',
    'Malaisie', 'Malawi', 'Maldives', 'Mali', 'Malte', 'Maroc', 'Maurice', 'Mauritanie',
    'Mexique', 'Moldavie', 'Monaco', 'Mongolie', 'Monténégro', 'Mozambique', 'Myanmar',
    'Namibie', 'Nauru', 'Népal', 'Nicaragua', 'Niger', 'Nigéria', 'Norvège',
    'Nouvelle-Zélande', 'Oman', 'Ouganda', 'Ouzbékistan', 'Pakistan', 'Palaos',
    'Palestine', 'Panama', 'Papouasie-Nouvelle-Guinée', 'Paraguay', 'Pays-Bas', 'Pérou',
    'Philippines', 'Pologne', 'Portugal', 'Qatar', 'RD Congo', 'République centrafricaine',
    'République dominicaine', 'République tchèque', 'Roumanie', 'Royaume-Uni', 'Russie',
    'Rwanda', 'Saint-Kitts-et-Nevis', 'Saint-Vincent-et-les-Grenadines', 'Sainte-Lucie',
    'Salvador', 'Samoa', 'Sénégal', 'Serbie', 'Seychelles', 'Sierra Leone', 'Singapour',
    'Slovaquie', 'Slovénie', 'Somalie', 'Soudan', 'Soudan du Sud', 'Sri Lanka', 'Suède',
    'Suisse', 'Suriname', 'Syrie', 'Tadjikistan', 'Tanzanie', 'Tchad', 'Thaïlande',
    'Timor oriental', 'Togo', 'Tonga', 'Trinité-et-Tobago', 'Tunisie', 'Turkménistan',
    'Turquie', 'Tuvalu', 'Ukraine', 'Uruguay', 'Vanuatu', 'Vatican', 'Venezuela',
    'Viêt Nam', 'Yémen', 'Zambie', 'Zimbabwe'
  ];

  // 🧠 État du formulaire
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    description_fr: '',
    type_contrat: '',
    ville: '',
    pays: '',
    filiale: filiale || ''
  });

  const [message, setMessage] = useState('');

  // 🔁 Mise à jour des champs
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setMessage('');
  };

  // 📤 Soumission du formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Client-side validation
    if (!formData.title.trim()) {
      setMessage('❌ Le titre du poste est obligatoire.');
      return;
    }

    if (!formData.description.trim()) {
      setMessage('❌ La description est obligatoire.');
      return;
    }

    if (!formData.description_fr.trim()) {
      setMessage('❌ La description en français est obligatoire.');
      return;
    }

    if (!formData.type_contrat) {
      setMessage('❌ Le type de contrat est obligatoire.');
      return;
    }

    if (formData.title.length > 255) {
      setMessage('❌ Le titre ne doit pas dépasser 255 caractères.');
      return;
    }

    try {
      await axios.post(`${process.env.REACT_APP_DOMAINE}/api/jobs`, formData);

      setMessage('✅ Offre créée avec succès');
      setFormData({
        title: '',
        description: '',
        description_fr: '',
        type_contrat: '',
        ville: '',
        pays: '',
        filiale: filiale || ''
      });
    } catch (err) {
      console.error("💥 Erreur complète :", err.response?.data || err.message);
      setMessage("❌ " + (err.response?.data?.error || err.message));
    }
  };

  return (
    <div className="container mt-4" style={{ maxWidth: '600px', backgroundColor: '#fff', padding: '20px', borderRadius: '8px' }}>
      <h3 className="mb-3" style={{ color: '#000' }}>🧾 Créer une offre d'emploi</h3>

      {message && <div className="alert alert-info">{message}</div>}

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label" style={{ color: '#000' }}>Titre du poste <span style={{ color: 'red' }}>*</span></label>
          <input
            className="form-control"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label" style={{ color: '#000' }}>Description <span style={{ color: 'red' }}>*</span></label>
          <textarea
            className="form-control"
            name="description"
            value={formData.description}
            onChange={handleChange}
            required
            rows={4}
          />
          <small className="text-muted">Syntaxe Markdown : # Titre, ## Sous-titre, **gras**, *italique*, - liste</small>
        </div>

        <div className="mb-3">
          <label className="form-label" style={{ color: '#000' }}>Description (Français) <span style={{ color: 'red' }}>*</span></label>
          <textarea
            className="form-control"
            name="description_fr"
            value={formData.description_fr}
            onChange={handleChange}
            required
            rows={4}
          />
          <small className="text-muted">Syntaxe Markdown : # Titre, ## Sous-titre, **gras**, *italique*, - liste</small>
        </div>

        <div className="mb-3">
          <label className="form-label" style={{ color: '#000' }}>Type de contrat <span style={{ color: 'red' }}>*</span></label>
          <select
            className="form-select"
            name="type_contrat"
            value={formData.type_contrat}
            onChange={handleChange}
            required
          >
            <option value="">-- Sélectionner --</option>
            <option value="CDI">CDI</option>
            <option value="CDD">CDD</option>
            <option value="Contractuel">Contractuel</option>
            <option value="Stage">Stage</option>
            <option value="Alternance">Alternance</option>
            <option value="Freelance">Freelance</option>
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label" style={{ color: '#000' }}>Ville <span style={{ color: 'red' }}>*</span></label>
          <input
            className="form-control"
            name="ville"
            value={formData.ville}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label" style={{ color: '#000' }}>Pays <span style={{ color: 'red' }}>*</span></label>
          <select
            className="form-select"
            name="pays"
            value={formData.pays}
            onChange={handleChange}
            required
          >
            <option value="">-- Sélectionner un pays --</option>
            {countries.map((country) => (
              <option key={country} value={country}>{country}</option>
            ))}
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label" style={{ color: '#000' }}>Entité <span style={{ color: 'red' }}>*</span></label>
          <select
            className="form-select"
            name="filiale"
            value={formData.filiale}
            onChange={handleChange}
            required
            disabled={!!filiale}
          >
            <option value="">-- Sélectionner une entité --</option>
            {ENTITIES.map((entity) => (
              <option key={entity} value={entity}>{entity}</option>
            ))}
          </select>
        </div>

        <button type="submit" className="btn btn-success mt-2">
          ✅ Créer l’offre
        </button>
      </form>
    </div>
  );
}

export default JobForm;
